import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Headline from 'components/headline';
const RoadmapNavigation = require('components/steps/roadmapNavigation').RoadmapNavigation;
import { FormattedText } from 'core/i18n';

class RASuitabilityTestWrapper extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            content,
            footerContent,
            buttonContinueAction,
            buttonContinueDisabled,
            buttonPrevAction,
            buttonCancelAction,
        } = this.props;

        return (
            <div className="prospects-step-content basic-layering">
                <Headline icon="holders" className="prospects-gutter">
                    <h2>
                        <FormattedText value="raSuitabilityTest-headline" />
                    </h2>
                </Headline>
                <div className="persona-data-view">
                    {content}
                    {footerContent}
                </div>
                <div className="row form__footer">
                    <RoadmapNavigation
                        buttonContinueAction={buttonContinueAction}
                        buttonContinueDisabled={buttonContinueDisabled}
                        buttonPrevAction={buttonPrevAction}
                        buttonCancelAction={buttonCancelAction}
                    />
                </div>
            </div>
        );
    }
}

RASuitabilityTestWrapper.propTypes = {
    content: PropTypes.node,
    footerContent: PropTypes.node,
    buttonContinueAction: PropTypes.func,
    buttonContinueDisabled: PropTypes.bool,
    buttonPrevAction: PropTypes.func,
    buttonCancelAction: PropTypes.func,
};
RASuitabilityTestWrapper.defaultProps = {
    content: null,
    footerContent: null,
    className: '',
    buttonContinueAction: () => {},
    buttonContinueDisabled: true,
    buttonPrevAction: () => {},
    buttonCancelAction: () => {},
};

export default RASuitabilityTestWrapper;
